import { IFilterDTO } from '../../api/plyca-dtos';
import { UserService } from '../../user.service';
import { BaseFormHeaderInfo } from '../../tasks/baseFormComponent/baseForm.component';
import {
  Component,
  OnInit,
  ElementRef,
  AfterContentInit,
  OnDestroy,
  ViewChild,
  TemplateRef,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable, of, throwError } from 'rxjs';
import { FormConfig } from '../../components/forms/form.objects';
import { I18nData, ProtocolDTO } from '../../api/plyca-dtos';
import {
  FilteredBaseFormComponent,
  TModel,
} from '../../tasks/baseFormComponent/filteredBaseForm.component';
import { DialogService, DynamicDialogConfig } from 'primeng-lts/dynamicdialog';
import {
  HelpService,
  HelpType,
} from '../../components/common/help/help.service';
import { PaginationDTO } from '../../api/PaginationModel';
import { ProtocolEditionComponent } from './protocol.edition.component';
import { ProtocolEvaluateComponent } from './protocolEvaluate.component';
import { catchError, finalize, tap } from 'rxjs/operators';
import { PlycaErrorHandler } from '../../../http/PlycaErrorHandler';

@Component({
  selector: 'protocolpanel-form',
  templateUrl: '../../tasks/baseFormComponent/baseForm.template.html',
  providers: [DialogService],
})
export class ProtocolsPanelComponent
  extends FilteredBaseFormComponent<ProtocolDTO>
  implements OnInit, AfterContentInit, OnDestroy {
  @ViewChild('actionsTemplate')
  fromTemplate: TemplateRef<any>;

  getObjectIdentifier() {
    throw new Error('Method not implemented.');
  }

  constructor(
    elem: ElementRef,
    public translationService: TranslateService,
    private userService: UserService,
    private plycaErrorHandler: PlycaErrorHandler,
    public helpService: HelpService
  ) {
    super(elem);
    this.subscribe(
      this.helpService.showContextHelpObservable(HelpType.PROTOCOLS)
    );
  }
  ngOnInit(): void {
    this.autosearch = true;

    super.ngOnInit();
  }
  ngOnDestroy(): void {
    super.ngOnDestroy();
  }
  ngAfterContentInit(): void { }
  getFormSettingURL(): string {
    return 'admin/protocolsFilterISettings.json';
  }
  getServiceURL(operation?: string): string {
    return this.configuration.PROTOCOL_SERVICE_URL;
  }
  getTitle(model: ProtocolDTO): string {
    return 'Protocols.edit.tooltip';
  }
  getHeaderInfo(): BaseFormHeaderInfo {
    let headerInfo = new BaseFormHeaderInfo();
    headerInfo.titleKey = 'ControlPanel.protocols.title';
    headerInfo.titleIcon = 'fas fa-project-diagram';
    return headerInfo;
  }
  initHeaderActions() {
    this.subscribe(
      this.headerActionsService.addAction(
        'General.reset.filters',
        'fas fa-undo',
        'btn-secondary',
        true
      ),
      (success) => {
        this.clearFilter();
        this.model.filter['organizationalUnit'] =
          this.userService.sessionInfo.user.organizationalUnit;
      }
    );

    this.subscribe(
      this.headerActionsService.addAction(
        'General.search.text',
        'fas fa-search',
        'btn-primary',
        true
      ),
      () => {
        this.searchProtocols();
      }
    );

    this.headerActionsService.addDivider();
    this.addBackAction();
  }
  private searchProtocols() {
    if (
      JSON.stringify(this.model.filter) === '{}' ||
      this.model.filter['application'] == undefined ||
      this.model.filter['organizationalUnit'] == undefined
    ) {
      this.uiService.showMessage(
        new I18nData('ControlPanel.inboxs.msg.filters'),
        new I18nData('General.info')
      );
    } else {
      this.search();
    }
  }

  searchFunction() {
    if (
      JSON.stringify(this.model.filter) === '{}' ||
      this.model.filter['application'] == undefined ||
      this.model.filter['organizationalUnit'] == undefined
    ) {
      this.uiService.showMessage(
        new I18nData('ControlPanel.protocols.msg.filters'),
        new I18nData('General.info')
      );
    } else {
      this.search();
    }
  }

  initModel(): TModel<ProtocolDTO> {
    // TODO FIltros
    // Que no se puedan limpiar los filtros para dejarlos en blanco, solo cambiarlos

    this.model = {} as TModel<ProtocolDTO>;
    this.model.ui = {};
    this.model.ui.mensaje = '';
    this.model.ui.showResults = false;

    this.model.filter = {};
    this.model.filter['organizationalUnit'] =
      this.userService.sessionInfo.user.organizationalUnit;

    const aplicativos = this.userService.sessionInfo.user.listProfiles.map(
      (p) => p.application
    );
    const uniqueArray = aplicativos.filter(
      (item, index) => aplicativos.indexOf(item) === index
    );
    this.model.ui['applicationList'] = uniqueArray.map((item) => {
      let dataItem = {
        identifier: item,
        description: item,
      };

      return dataItem;
    });

    this.model.filter['application'] = this.model.ui['applicationList'][0];

    return this.model;
  }
  updateTableModel(result: PaginationDTO<ProtocolDTO>): TModel<ProtocolDTO> {
    if (result?.content) {
      let content: ProtocolDTO[] = result.content;
      this.model.tableModel = content;
      this.model.ui.mensaje =
        this.translationService.instant('General.total') +
        ' ' +
        content.length +
        ' ' +
        this.translationService.instant('ControlPanel.protocols.title');
    } else {
      this.model.ui.mensaje =
        this.translationService.instant('General.total') +
        ' ' +
        0 +
        ' ' +
        this.translationService.instant('ControlPanel.protocols.title');
    }

    this.model.ui.showResults = true;

    return this.model;
  }

  dtoToModel(dto: ProtocolDTO): Observable<TModel<ProtocolDTO>> {
    throw new Error('Method not implemented.');
  }
  modelToDTO(model: TModel<ProtocolDTO>): ProtocolDTO {
    throw new Error('Method not implemented.');
  }
  filterToParam(): IFilterDTO {
    let params = [];
    if (
      this.model.filter['organizationalUnit'] &&
      this.model.filter['organizationalUnit'].identifier
    ) {
      delete params['organizationalUnit'];
      params['organizationalUnit'] =
        this.model.filter['organizationalUnit'].identifier;
    } else {
      delete params['organizationalUnit'];
    }

    if (
      this.model.filter['application'] &&
      this.model.filter['application'].identifier
    ) {
      delete params['application'];
      params['application'] = this.model.filter['application'].identifier;
    } else {
      delete params['application'];
    }
    // params['expand'] = 'expansionSet:manage';
    params['expand'] = 'expansionSet:collection';
    return params;
  }

  configureFormConfig(formConfig: FormConfig): Observable<FormConfig> {
    formConfig.showValidations = true;
    formConfig.isModalWindow = false;
    formConfig.functions.push({
      identifier: 'up',
      fn: this.up.bind(this),
    });
    formConfig.functions.push({
      identifier: 'down',
      fn: this.down.bind(this),
    });

    formConfig.functions.push({
      identifier: 'activate',
      fn: this.activate.bind(this),
    });
    formConfig.functions.push({
      identifier: 'copy',
      fn: this.copy.bind(this),
    });

    formConfig.functions.push({
      identifier: 'delete',
      fn: this.deleteProtocol.bind(this),
    });

    formConfig.functions.push({
      identifier: 'add',
      fn: this.add.bind(this),
    });
    formConfig.functions.push({
      identifier: 'edit',
      fn: this.edit.bind(this),
    });
    formConfig.functions.push({
      identifier: 'show',
      fn: this.show.bind(this),
    });

    formConfig.functions.push({
      identifier: 'cancel',
      fn: this.cancel.bind(this),
    });

    formConfig.functions.push({
      identifier: 'searchFunction',
      fn: this.searchFunction.bind(this),
    });

    formConfig.functions.push({
      identifier: 'evaluate',
      fn: this.evaluate.bind(this),
    });

    return of(formConfig);
  }

  public cancel(model: any) {
    this.uiService.showSuccess(
      this.translate.instant('General.msg.cancel'),
      this.translate.instant('General.info'),
      'warn'
    );
  }

  // Funciones del formulario
  show(model: any) {
    this.modalOpen(model, 'show');
  }
  edit(model: any) {
    this.modalOpen(model, 'update');
  }
  add(model: any) {
    this.modalOpen(model, 'insert');
  }
  copy(model: any) {
    this.modalOpen(model, 'copy');
  }
  modalOpen(model: any, operation: string) {
    let css = 'formEdition';
    let title = 'ControlPanel.protocols.actions.edit';
    if (operation === 'insert' || operation === 'copy') {
      title = 'ControlPanel.protocols.actions.new';
    }
    if (operation === 'show') {
      title = 'ControlPanel.protocols.actions.show';
      css = 'viewStyle';
    }

    let config: DynamicDialogConfig = {
      header: this.translate.instant(title),
      width: '90%',
      styleClass: css,
    };
    if (operation === 'insert') {
      config['id'] = 'new';
      config['organismohex'] =
        this.model.filter['organizationalUnit'].identifier;
      config['application'] = this.model.filter['application'].identifier;
    } else {
      config['id'] = model.identifier;
    }

    config['operation'] = operation;
    // config['readonly'] = readonly
    this.waitService.startWaiting();
    const dialog = this.dialogService.open(ProtocolEditionComponent, config);
    dialog.onClose.subscribe((newInvoice) => {
      this.search();
    });
  }

  evaluate(model: any) {
    let css = 'formEdition';
    let title = 'ControlPanel.protocols.actions.evaluate.title';

    let config: DynamicDialogConfig = {
      header: this.translate.instant(title),
      width: '90%',
      styleClass: css,
    };

    config['protocol'] = model;

    this.waitService.startWaiting();
    const dialog = this.dialogService.open(ProtocolEvaluateComponent, config);
    dialog.onClose.subscribe((newInvoice) => {
      this.search();
    });
  }

  public preEditRowFunction(model: any) {
    console.log(model);
  }

  public noImplemented() {
    this.uiService.showSuccess(
      'Operación no implementada',
      this.translate.instant('General.info'),
      'warn'
    );
  }

  public up(protocol: ProtocolDTO): void {
    this.patch(protocol, 'MOVE_UP');
  }

  public down(protocol: ProtocolDTO): void {
    this.patch(protocol, 'MOVE_DOWN');
  }

  public activate(protocol: ProtocolDTO): void {
    this.patch(protocol, 'ENABLE');
  }

  public patch(protocol: ProtocolDTO, operation: string): void {
    this.uiService.showConfirmMessage({
      message: this.translationService.instant(
        'General.confirm.action.execute'
      ),
      header: this.translationService.instant('General.warn'),
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        let objToPatch = new ProtocolDTO();
        objToPatch.identifier = protocol.identifier;
        if (operation === 'ENABLE') {
          objToPatch.enabled = protocol.enabled;
        }

        this.subscribe(
          this.plycaService
            .patch<ProtocolDTO>(
              this.configuration.PROTOCOL_SERVICE_URL,
              objToPatch,
              operation
            )
            .pipe(
              tap(() => {
                this.uiService.showSuccess(this.translate.instant('General.msg.updateok'), this.translate.instant('General.info'),
                  'success');

                this.searchProtocols();
              }),
              catchError((error: any) => {
                this.plycaErrorHandler.showServerError(error);
                return throwError(error);
              })
            ),
          () => { }
        );
      },
      reject: () => {
        this.cancel(protocol);
      },
    });
  }


  public deleteProtocol(model: any): void {
    this.subscribe(
      this.delete(true, model)
        .pipe(tap((result) => {

          this.uiService.showSuccess(this.translate.instant('General.msg.updateok'), this.translate.instant('General.info'),
            'success');

          this.searchProtocols();
        }),
          catchError((error: any) => {
            this.plycaErrorHandler.showServerError(error);
            return throwError(error);
          }))
    );

  }

  protected delete(showWait = true, model: any): Observable<any> {
    if (showWait) {
      this.waitService.startWaiting();

    }


    let deleteObs = this.plycaService.delete(
      this.getServiceURL(),
      model.identifier
    ).pipe(
      catchError((error: any) => this.manageHttpError(error, false)),
      finalize(() => {
        if (showWait) {
          this.waitService.cancelWaiting();
        }
      })
    );
    return deleteObs;
  }


}
